var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EditBase, useNotify, useRecordContext, useUpdate } from "react-admin";
import { ElectionDataForm } from "./ElectionDataForm";
import { ITemplateMethod } from "@/types/templates";
import { ContestsOrder } from "@sequentech/ui-core";
import { serializeIvrEntityAnnotations } from "@/utils/ivr";
import { SLATES_FORM_FIELD, formatSlatesProblems, slatesProblemsFromError, writeSlatesConfiguration, } from "@/utils/slates";
export var EditElectionData = function () {
    var update = useUpdate()[0];
    var notify = useNotify();
    var record = useRecordContext();
    function updateContestsOrder(data) {
        return __awaiter(this, void 0, void 0, function () {
            var electionPresentation, contests, index, contest, contestPresentation;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        electionPresentation = data.presentation;
                        if (!((electionPresentation === null || electionPresentation === void 0 ? void 0 : electionPresentation.contests_order) === ContestsOrder.CUSTOM)) return [3 /*break*/, 4];
                        contests = (_a = data.contestsOrder) !== null && _a !== void 0 ? _a : [];
                        index = 0;
                        _c.label = 1;
                    case 1:
                        if (!(index < contests.length)) return [3 /*break*/, 4];
                        contest = contests[index];
                        contestPresentation = ((_b = contest.presentation) !== null && _b !== void 0 ? _b : {});
                        if (!(contestPresentation.sort_order !== index)) return [3 /*break*/, 3];
                        return [4 /*yield*/, update("sequent_backend_contest", {
                                id: contest.id,
                                data: {
                                    presentation: __assign(__assign({}, contestPresentation), { sort_order: index }),
                                },
                                previousData: contest,
                            }, { returnPromise: true })];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        index++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var transform = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, receipts, value, key, enabled_language_codes, key, language_conf, fromPresentationDescription, problems, message;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateContestsOrder(data)];
                case 1:
                    _j.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _j.sent();
                    notify(error_1 instanceof Error ? error_1.message : String(error_1), { type: "error" });
                    throw error_1;
                case 3:
                    delete data.contestsOrder;
                    receipts = {};
                    for (value in Object.values(ITemplateMethod)) {
                        key = Object.keys(ITemplateMethod)[value];
                        receipts[key] = {};
                        receipts[key]["allowed"] = ((_a = data.allowed) === null || _a === void 0 ? void 0 : _a[key]) || false;
                        receipts[key]["template"] = ((_b = data.template) === null || _b === void 0 ? void 0 : _b[key]) || null;
                    }
                    data.receipts = __assign({}, receipts);
                    delete data.allowed;
                    delete data.template;
                    delete data.scheduledOpening;
                    delete data.scheduledClosing;
                    enabled_language_codes = [];
                    for (key in data.enabled_languages) {
                        if (typeof data.enabled_languages[key] === "boolean" && data.enabled_languages[key]) {
                            enabled_language_codes.push(key);
                        }
                    }
                    language_conf = {
                        enabled_language_codes: enabled_language_codes,
                    };
                    // i18n
                    // is alll object, no change needed
                    delete data.enabled_languages;
                    fromPresentationDescription = ((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.presentation) === null || _c === void 0 ? void 0 : _c.i18n) === null || _d === void 0 ? void 0 : _d.en) === null || _e === void 0 ? void 0 : _e.description) ||
                        ((_f = data === null || data === void 0 ? void 0 : data.presentation) === null || _f === void 0 ? void 0 : _f.i18n[Object.keys(data.presentation.i18n)[0]].description) ||
                        "";
                    data.description = fromPresentationDescription;
                    try {
                        data.annotations = writeSlatesConfiguration(serializeIvrEntityAnnotations(data.annotations), data[SLATES_FORM_FIELD]);
                    }
                    catch (error) {
                        problems = slatesProblemsFromError(error);
                        message = problems
                            ? formatSlatesProblems(problems)
                            : error instanceof Error
                                ? error.message
                                : String(error);
                        notify(message, { type: "error" });
                        throw error;
                    }
                    delete data[SLATES_FORM_FIELD];
                    return [2 /*return*/, __assign(__assign({}, data), { presentation: __assign(__assign(__assign({}, data.presentation), data.configuration), { language_conf: __assign(__assign({}, language_conf), { default_language_code: (_h = (_g = data === null || data === void 0 ? void 0 : data.presentation) === null || _g === void 0 ? void 0 : _g.language_conf) === null || _h === void 0 ? void 0 : _h.default_language_code }) }) })];
            }
        });
    }); };
    return (_jsx(EditBase, { redirect: ".", transform: transform, children: record ? _jsx(ElectionDataForm, {}) : null }));
};
